import { isGreaterThanZero } from './greater-than-zero.js';
import { SkipOperator } from './types.js';
function conditionHolds(condition, answers, hidden) {
    const { triggerQuestionId } = condition;
    if (triggerQuestionId === null || hidden.has(triggerQuestionId))
        return false;
    const answer = answers.get(triggerQuestionId);
    if (!answer)
        return false;
    switch (condition.operator) {
        case SkipOperator.AnyOf:
            return answer.selectedOptionIds.some((id) => condition.optionIds.includes(id));
        case SkipOperator.AnyAnswer:
            return answer.selectedOptionIds.length > 0;
        case SkipOperator.GreaterThanZero:
            return isGreaterThanZero(answer.text);
    }
}
function isHidden(rule, answers, hidden) {
    const matches = rule.conditions.filter((c) => conditionHolds(c, answers, hidden)).length;
    const satisfied = rule.combine === 'all'
        ? matches === rule.conditions.length
        : rule.combine === 'exactly_one'
            ? matches === 1
            : matches > 0;
    return rule.direction === 'show' ? !satisfied : satisfied;
}
function pass(rules, answers, hidden) {
    const next = new Set();
    for (const rule of rules) {
        if (isHidden(rule, answers, hidden))
            next.add(rule.targetQuestionId);
    }
    return next;
}
const sameSet = (a, b) => a.size === b.size && [...a].every((id) => b.has(id));
/**
 * The questions the rules hide for these answers. A hidden trigger counts as unanswered,
 * so hiding cascades; iterating to a fixed point makes the result independent of question
 * order. Show rules only ever add to the hidden set, so they settle within one pass per
 * rule; a hide rule inside a cycle can oscillate, and whatever is still flipping when the
 * pass limit is reached is shown.
 */
export function evaluateVisibility(rules, answers) {
    let hidden = new Set();
    for (let i = 0; i <= rules.length; i++) {
        const next = pass(rules, answers, hidden);
        if (sameSet(next, hidden))
            return next;
        hidden = next;
    }
    const after = pass(rules, answers, hidden);
    return new Set([...hidden].filter((id) => after.has(id)));
}
//# sourceMappingURL=evaluate.js.map